// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608182025/js/" + chunkId + "." + {"44":"0e43f7fb","225":"1bbd4985","481":"379c5d72","486":"83355b70","770":"f36b3282"}[chunkId] + ".0.9935566736624438.chunk.js";
};